import React, { useEffect } from "react";

// === SUGGESTED QUESTIONS ===
// UPDATED: These keywords match your Python Backend exactly.
const SUGGESTED_QUESTIONS = [
  "🚚 Do you have delivery?",       // Matches keyword "delivery"
  "💳 What are payment options?",    // Matches keyword "payment"
  "📍 Where is your location?",      // Matches keyword "location"
  "💰 Give me budget tips",          // Matches keyword "tip"
  "🍚 Rice under RM 10",             // Standard search
  "🛒 Calculate 1kg rice + 2 sardine" // Math mode
];

//declare the ChatbotModal component
const ChatbotModal = ({
  open,
  onClose,
  chatMessages,
  userInput,
  setUserInput,
  handleChatSubmit,
  chatEndRef
}) => {

  useEffect(() => {
    if (open && chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [chatMessages, open, chatEndRef]);

  // === RENDERER ===
  const formatMessage = (text) => {
    return text.split('\n').map((line, i) => {
      
      if (line.trim() === '---') {
        return <hr key={i} className="my-3 border-[#FFB347] border-dashed opacity-60" />;
      }

      const imageMatch = line.match(/!\[(.*?)\]\((.*?)\)/);
      if (imageMatch) {
        return (
          <div key={i} className="my-3 flex justify-start">
            <img 
              src={imageMatch[2]} 
              alt="Product" 
              className="rounded-lg max-h-40 max-w-full w-auto border border-[#FFCC99] shadow-sm object-contain bg-white" 
              onError={(e) => { e.target.style.display = 'none'; }} 
            />
          </div>
        );
      }

      const parts = line.split('**');
      return (
        <div key={i} className="min-h-[1.5em] break-words whitespace-pre-wrap leading-relaxed">
          {parts.map((part, index) => 
            index % 2 === 1 ? <strong key={index} className="font-semibold text-black">{part}</strong> : part
          )}
        </div>
      );
    });
  };

  // === HANDLER: CLICKING A SUGGESTION ===
  const handleSuggestionClick = (question) => {
    setUserInput(question); // Fills the input box
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-end md:items-center justify-center z-50 transition-opacity duration-300">
      <div className="bg-[#FFF7E6] border border-[#FFD8A6] flex flex-col shadow-2xl
                      w-full h-[85vh] rounded-t-2xl
                      md:w-[500px] md:max-h-[80vh] md:rounded-2xl md:h-auto overflow-hidden">

        {/* Header */}
        <div className="flex justify-between items-center p-4 bg-gradient-to-r from-[#FF8C00] to-[#FFA500] text-black md:rounded-t-2xl shrink-0">
          
          <div className="flex items-center gap-2">
            <span className="text-2xl">🤖</span>
            <h2 className="text-lg md:text-xl font-bold text-black">Grocery Assistant</h2>
          </div>

          <button 
            onClick={onClose} 
            className="text-black hover:text-white/80 font-bold text-3xl leading-none px-2 transition-colors"
          >
            &times;
          </button>
        </div>

        {/* Chat Area */}
        <div className="flex-1 overflow-y-auto bg-gray-50 p-4 space-y-4">
          {chatMessages.map((msg, i) => {
            const isUser = msg.role === "user";
            return (
              <div key={i} className={`flex w-full ${isUser ? "justify-end" : "justify-start"}`}>
                <div className={`max-w-[85%] p-4 rounded-2xl text-sm shadow-md transition-all ${
                  isUser 
                    ? "bg-[#FF8C00] text-white rounded-br-none" 
                    : "bg-[#FFE5CC] text-black border border-[#FFCC99] rounded-bl-none"
                }`}>
                  {formatMessage(msg.text)}
                </div>
              </div>
            );
          })}
          
          {/* === SUGGESTED QUESTIONS (Quick Replies) === */}
          {/* Only show if chat is empty (only has the greeting) */}
          {chatMessages.length === 1 && (
            <div className="mt-4 px-2 animate-in fade-in slide-in-from-bottom-2 duration-500">
              <p className="text-xs font-bold text-gray-400 mb-3 uppercase tracking-wide text-center">
                Ask me anything
              </p>
              <div className="grid grid-cols-1 gap-2">
                {SUGGESTED_QUESTIONS.map((q, idx) => (
                  <button
                    key={idx}
                    onClick={() => handleSuggestionClick(q)}
                    className="w-full text-left px-4 py-3 bg-white border border-[#FFD8A6] rounded-xl text-sm text-gray-700 hover:bg-[#FFF0D9] hover:border-[#FF8C00] active:scale-[0.98] transition-all shadow-sm flex items-center gap-2 group"
                  >
                    <span className="group-hover:translate-x-1 transition-transform duration-200">
                      {q}
                    </span>
                  </button>
                ))}
              </div>
            </div>
          )}

          <div ref={chatEndRef}></div>
        </div>

        {/* Input */}
        <div className="p-4 bg-white border-t border-gray-200 md:rounded-b-2xl shrink-0">
          <form onSubmit={(e) => { e.preventDefault(); handleChatSubmit(); }} className="flex gap-2">
            <input
              value={userInput}
              onChange={(e) => setUserInput(e.target.value)}
              placeholder="Type or click a suggestion..."
              className="flex-1 p-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#FF8C00] bg-white text-black text-base" 
            />
            <button type="submit" className="px-6 text-white rounded-xl font-bold transition-all shadow-md bg-[#FF8C00] hover:bg-[#e67e00] hover:shadow-lg active:scale-95">
              Send
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ChatbotModal;
